import { useReducer, ReactNode, useEffect } from 'react';
import { mapReducer } from './reducers';
import { initialValues, MapStateContext } from './utils';

export const MapProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(mapReducer, initialValues);

  const value = {
    ...state,
    mapDispatch: dispatch
  }
  
  return (
    <MapStateContext.Provider value={value}>
      {children}
    </MapStateContext.Provider>
  )
}
